// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.unlock-manual-remarks-tooltip {\n  max-width: 380px;\n  white-space: pre-line;\n  line-height: 1.6;\n}\n", ""]);
// Exports
module.exports = exports;
